/**
 * RichText module. Rendering is owned by the portable layer, which is the only
 * place that knows the rich text format.
 */
export { default } from "@/components/portable/RichTextRenderer";
